import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
  resources: {
    'en-GB': {
      translation: {
        overview: 'overview',
      },
    },
    'el-GR': {
      translation: {
        overview: 'Επισκόπηση',
      },
    },
  },
  lng: 'en-GB',
  fallbackLng: 'en-GB',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
